import Vue from 'vue'

// axios
import axios from 'axios'
import apiLinks from '../axios.config'
// eslint-disable-next-line
import store from "../store";

import { getItem } from '@/@core/utils/storage-utils'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: apiLinks.main,
  // timeout: 1000,
})

// NH Reports API instance
const axiosReportsIns = axios.create({
  baseURL: apiLinks.reports,
})

const addAuthInterceptor = axiosInstance => {
  axiosInstance.interceptors.request.use(request => {
    const authToken = getItem('jwtToken')
    // eslint-disable-next-line no-param-reassign
    // eslint-disable-next-line
  if (authToken !== null) {request.headers.Token = authToken}
    return request
  })
}

addAuthInterceptor(axiosIns)
addAuthInterceptor(axiosReportsIns)

// Attach one of them to Vue prototype if that’s your default
Vue.prototype.$http = axiosIns

// Export all instances so you can import and use them as needed
export { axiosIns, axiosReportsIns }
